import { render } from "./node.vue?vue&type=template&id=2b67f7e3"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__